// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.choose-plan {
  padding: 40px 20px;
}

.page-title {
  margin-bottom: 40px;
  font-weight: 700;
  color: #152046;
}

.plan-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  margin-bottom: 30px;
  overflow: hidden;
  border: 1px solid #eaeaea;
}

.plan-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

/* 卡片圖片區 */
.plan-img-wrapper {
  width: 100%;
  height: 400px; /* 固定高度，讓三張卡片圖片區塊一樣大 */
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9; /* 圖片比例不同時，空白區塊顯示淺灰 */
}

.plan-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* 等比縮放，完整顯示，不裁切 */
}

.plan-header {
  background: linear-gradient(135deg, #4a90e2, #357ABD);
  color: #fff;
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  padding: 12px;
}

.plan-body {
  padding: 20px;
  text-align: center;
}

.plan-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.plan-desc {
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
  min-height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/pages/quickbuy/styles/quickbuy.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;AAEF;;AACA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AAEF;;AACA;EACE,gBAAA;EACA,mBAAA;EACA,yCAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AAEF;;AACA;EACE,2BAAA;EACA,0CAAA;AAEF;;AACA,UAAA;AACA;EACE,WAAA;EACA,aAAA,EAAA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA,EAAA,qBAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA,EAAA,kBAAA;AAEF;;AACA;EACE,qDAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;AAEF;;AACA;EACE,aAAA;EACA,kBAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAEF;;AACA;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAEF","sourcesContent":[".choose-plan {\r\n  padding: 40px 20px;\r\n}\r\n\r\n.page-title {\r\n  margin-bottom: 40px;\r\n  font-weight: 700;\r\n  color: #152046;\r\n}\r\n\r\n.plan-card {\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\r\n  transition: all 0.3s ease;\r\n  cursor: pointer;\r\n  margin-bottom: 30px;\r\n  overflow: hidden;\r\n  border: 1px solid #eaeaea;\r\n}\r\n\r\n.plan-card:hover {\r\n  transform: translateY(-6px);\r\n  box-shadow: 0 8px 20px rgba(0,0,0,0.15);\r\n}\r\n\r\n/* 卡片圖片區 */\r\n.plan-img-wrapper {\r\n  width: 100%;\r\n  height: 400px;     /* 固定高度，讓三張卡片圖片區塊一樣大 */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #f9f9f9; /* 圖片比例不同時，空白區塊顯示淺灰 */\r\n}\r\n\r\n.plan-img {\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n  object-fit: contain; /* 等比縮放，完整顯示，不裁切 */\r\n}\r\n\r\n.plan-header {\r\n  background: linear-gradient(135deg, #4a90e2, #357ABD);\r\n  color: #fff;\r\n  font-size: 22px;\r\n  font-weight: bold;\r\n  text-align: center;\r\n  padding: 12px;\r\n}\r\n\r\n.plan-body {\r\n  padding: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.plan-title {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  margin-bottom: 10px;\r\n  color: #333;\r\n}\r\n\r\n.plan-desc {\r\n  color: #666;\r\n  font-size: 14px;\r\n  margin-bottom: 20px;\r\n  min-height: 40px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
